import { render, staticRenderFns } from "./moreInstructionEdit.vue?vue&type=template&id=609a7645&scoped=true&"
import script from "./moreInstructionEdit.vue?vue&type=script&lang=js&"
export * from "./moreInstructionEdit.vue?vue&type=script&lang=js&"
import style0 from "./moreInstructionEdit.vue?vue&type=style&index=0&id=609a7645&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "609a7645",
  null
  
)

export default component.exports